// extracted by mini-css-extract-plugin
export var copy = "AnimatedContentCard-module--copy--8e9bc";
export var evergreen = "AnimatedContentCard-module--evergreen--056bf";
export var fadeIn = "AnimatedContentCard-module--fadeIn--362e3";
export var image = "AnimatedContentCard-module--image--89f50";
export var section = "AnimatedContentCard-module--section--293ef";